import { type Module } from 'vuex'
import type { IFormComponent } from '@/modules/Administracion/interfaces'
import type { IConfEntidades } from '../interfaces';

export interface StateComponentsMigrate {
  componentesMarcados: IFormComponent[],
  entidadesSeleccionadas: IConfEntidades[],
}
 const componentsMigrate: Module<StateComponentsMigrate, unknown> = {
  namespaced: true,  state: (): StateComponentsMigrate => {
    return {
      componentesMarcados: [] as IFormComponent[],
      entidadesSeleccionadas: [] as IConfEntidades[],
    }
  },
  mutations: {
    setEntidadesSeleccionadas(state: StateComponentsMigrate, data: { entidades: IConfEntidades[] }) {
      state.entidadesSeleccionadas = data.entidades;
    },
    pushComponentesMarcados(state: StateComponentsMigrate, data: { marcado: IFormComponent }) {
      state.componentesMarcados.push(data.marcado);   
    },
    removeComponentesMarcados(state: StateComponentsMigrate, data: { marcado: IFormComponent }) {
      state.componentesMarcados = state.componentesMarcados.filter(e => e.name !== data.marcado.name);
    },
  },  
  getters: {
    componentesMarcados: (state: StateComponentsMigrate) => {
      return state.componentesMarcados;
    },
    entidadesSeleccionadas: (state: StateComponentsMigrate) => {
      return state.entidadesSeleccionadas;
    }
  },
  actions: {},
}
export default componentsMigrate

